// extracted by mini-css-extract-plugin
export default {"content_area":"Layout_content_area__ffueW","body_content":"Layout_body_content__mTTwc"};